import { render, staticRenderFns } from "./RejectedValidations.vue?vue&type=template&id=6dc75820&"
import script from "./RejectedValidations.vue?vue&type=script&lang=js&"
export * from "./RejectedValidations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports